import React from 'react';
import { Col } from 'react-bootstrap';
import TooltipOverlay from '../../../../../../shared/components/tooltip/Tooltip';
import { FiInfo } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../store/rootReducer';
import { UserRoles } from '../../../../../../enum/UserRoles';

interface PayoutSectionOverviewProps {
    isLongTerm?: boolean;
    invoicePeriod?: string;
    paymentTerms?: string;
    paymentTermsCustom?: string;
}
const PayoutSectionOverview = ({
    isLongTerm,
    invoicePeriod,
    paymentTerms,
    paymentTermsCustom,
}: PayoutSectionOverviewProps) => {
    const { userType } = useSelector((state: IAllStates) => state.auth.user);
    const isBrandSide = [UserRoles.BRAND, UserRoles.BRAND_MASTER].includes(userType as any);
    const { t } = useTranslation();

    return (
        <>
            <Col md={6} className="d-flex">
                <div>
                    <h6 className="text-muted">
                        {t(`brand.campaign.briefing.step8.${isBrandSide ? 'payment_terms_brand' : 'payment_terms'}`)}
                    </h6>
                    {paymentTerms ? (
                        <p className={`${!!paymentTermsCustom ? 'mb-2' : 'mb-3'}`}>
                            {t(`brand.campaign.briefing.step8.payment_terms_type.${paymentTerms}`)}
                        </p>
                    ) : (
                        '-'
                    )}
                </div>
                <TooltipOverlay className="ms-2" content={t(`brand.campaign.briefing.step8.payment_terms_tooltip`)}>
                    <FiInfo size={14} />
                </TooltipOverlay>
            </Col>

            {isLongTerm && (
                <Col md={6} className="d-flex">
                    <div>
                        <h6 className="text-muted"> {t('brand.campaign.briefing.step8.payout_method')}</h6>
                        <p className={`${!!invoicePeriod ? 'mb-2' : 'mb-3'}`}>
                            {!!invoicePeriod ? t(`brand.campaign.briefing.step8.payment_method.${invoicePeriod}`) : '-'}
                        </p>
                    </div>
                    <TooltipOverlay className="ms-2" content={t(`brand.campaign.briefing.step8.payout_method_tooltip`)}>
                        <FiInfo size={14} />
                    </TooltipOverlay>
                </Col>
            )}
            <Col md={12}>
                {paymentTermsCustom && (
                    <h6 className="text-muted">
                        {t(
                            `brand.campaign.briefing.step8.${
                                isBrandSide ? 'payment_terms_description_brand' : 'payment_terms_description'
                            }`
                        )}
                    </h6>
                )}
                {!!paymentTermsCustom && <p className="mb-3">{paymentTermsCustom}</p>}
            </Col>
        </>
    );
};

export default PayoutSectionOverview;
